module.exports = __webpack_public_path__ + "img/ic-sport.b9ad87d0.svg";